import styled from "styled-components";
import { default as SlickSlider } from "@ant-design/react-slick";

import Box from "../../layout/boxes/Box";

import {
	StyledCarouselProps,
	StyledCarouselItemProps,
	StyledCarouselContainerProps,
} from "./Carousel.types";

export const StyledCarouselContainer = styled(
	Box
)<StyledCarouselContainerProps>`
	display: block;
	position: relative;

	&:hover {
		.CarouselArrow {
			opacity: 1;
		}

		.Carousel__scrollbar {
			height: 8px;
			::-webkit-slider-thumb {
				height: 8px;
			}
		}
	}
`;

export const StyledCarousel = styled(SlickSlider)<StyledCarouselProps>`
	position: relative;
	overflow: hidden;
	border-radius: ${({ theme }) => theme.radii.lg};

	.slick-track {
		display: flex;
	}

	.slick-list {
		position: relative;
		z-index: 2;
		margin: 0 -13px;
	}

	.slick-slide {
		opacity: 1 !important;
		transition: none !important;

		& > div {
			height: 100%;
			margin: 0 13px;

			& > div {
				outline: none;
				height: 100%;
				display: flex !important;
				position: relative;
			}
		}
	}
`;

export const StyledCarouselItem = styled(Box)<StyledCarouselItemProps>`
	display: flex;
	position: relative;
	border-radius: ${({ theme }) => theme.radii.lg};
	overflow: hidden;
	left: 0;
	${({ slidesToShow, index }) => {
		return {
			...(slidesToShow === 1 && {
				zIndex: Number(index || 0),
				transition: "left 600ms ease-in",
				":not(:last-child)": {
					position: "absolute",
				},
				":not(.Carousel__item--active)": {
					left: "-100%",
				},
			}),
		};
	}}
`;
